import { Link as RouterLink } from '@ovComponents/2-component/orgLink/orgLink';
import {
  FlagGlossaryFiltersCard,
  FlagGlossaryGridCard,
  FlagGlossaryKpiSummary,
  useFlagGlossaryPage,
} from '@ovComponents/4-module/flagGlossary';
import { Box, Button, Typography, useTheme } from 'hephaestus/web';

const FlagGlossaryPage = () => {
  const theme = useTheme();
  const { t, kpiProps, filtersProps, gridProps } = useFlagGlossaryPage(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant='titleMedium'>{t('flagGlossary.title')}</Typography>
        <Button
          component={RouterLink}
          to='/reconciliation/flags'
          color='primary'
          size='small'
        >
          {t('flagGlossary.backToFlags')}
        </Button>
      </Box>
      <FlagGlossaryKpiSummary {...kpiProps} />
      <FlagGlossaryFiltersCard {...filtersProps} theme={theme} />
      <FlagGlossaryGridCard {...gridProps} />
    </Box>
  );
};

export default FlagGlossaryPage;
